<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="disabled" [multiple]="multiple"
           [placeholder]="'hx.country-select.placeholder.chooseCountry' | transloco" [clearable]="clearable">
  <ng-option *ngFor="let op of options" [value]="op.id">{{ op.title | uiLabel }}</ng-option>
</ng-select>
